import FunnelCartWidget from './funnel-chart.widget';
export default FunnelCartWidget;
